import { gql } from '@apollo/client'

export const USER_STATUS = gql`
  query userStatus($user_id: Int!) {
    userStatus(user_id: $user_id) {
      user_id
      status
      isOnline
      isAvailable
    }
  }
`
export const INTEGRATION_LINKS = gql`
  query IntegrationLinks($where: WhereIntegrationLink) {
    integrationLinks(where: $where) {
      id
      template
      integration {
        id
        name
      }
      integration_link_type {
        id
        name
      }
    }
  }
`
export const GET_MEDIA_FILES_BY_IDS = gql`
  query MediaEntriesByIds($ids: [Int]!) {
    mediaEntriesByIds(ids: $ids) {
      id
      title
      url
      type
    }
  }
`

export const GET_SAMPLE_VOICES = gql`
  query GetSampleVoices {
    _unauthedSampleVoices {
      ALESS
      ALESS_ES
      ANDRES
      ANDRES_ES
      JACKI
      KIM
      MARK
      RAISHA
      SEKOYYA
      SUNNY
    }
  }
`
